var _style, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogomovil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 380.44 380.44",
    style: {
      enableBackground: "new 0 0 380.44 380.44"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFCE00;}\n\t.st1{fill:#000D30;}\n\t.st2{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.88,113.77c-17.47,0-31.63-14.69-31.63-32.16V80H116.72v1.61c0,17.47-14.15,32.16-31.63,32.16h-2.14v48.53 c0,54.27,27.22,104.64,72.38,134.74l29.66,19.6l29.66-19.6c45.15-30.1,72.38-80.47,72.38-134.74v-48.53H284.88z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "144.19,104.3 151.03,104.3 145.5,107.96 147.61,114.36 142.08,110.2 136.55,114.12 138.66,108  133.12,104.3 139.96,104.3 142.08,97.79 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "165.41,104.3 172.25,104.3 166.72,107.96 168.83,114.36 163.3,110.2 157.77,114.12 159.88,108  154.35,104.3 161.18,104.3 163.3,97.79 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "186.64,104.3 193.47,104.3 187.94,107.96 190.05,114.36 184.52,110.2 178.99,114.12 181.1,108  175.57,104.3 182.41,104.3 184.52,97.79 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "207.86,104.3 214.7,104.3 209.16,107.96 211.28,114.36 205.74,110.2 200.21,114.12 202.33,108  196.79,104.3 203.63,104.3 205.74,97.79 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "229.08,104.3 235.92,104.3 230.39,107.96 232.5,114.36 226.97,110.2 221.44,114.12 223.55,108  218.01,104.3 224.85,104.3 226.97,97.79 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.88,139.65l-10.13-14.4h-20.77v93.7c-1.55,15.56,6.7,20.88,6.7,20.88l13.95,9.01V156.5l10.38,15.15 l10.05-14.74v119.5l20.99,13.51V125.25h-20.6L147.88,139.65z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.62,183.21l6.31-7.78v-50.5h-61.47v165.31l49.51-39.86c12.29-10.11,12.29-29.29,12.29-29.29V191.4 L245.62,183.21z M230.99,220.06l-20.1,13.31v-36.44h20.1V220.06z M230.99,171.75h-20.1v-20.88h20.1V171.75z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogomovil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logomovil.ca1905eaa9c3cc3d79809cc8a84dce1d.svg";